// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_0fce717cdb--checkbox--1TQxm","handler":"_0fce717cdb--handler--6bU55","box":"_0fce717cdb--box--VTgYk","hidden_input":"_0fce717cdb--hidden_input--1ELK2"};